// extracted by mini-css-extract-plugin
export default {"rightBlock":"styles_rightBlock__v60BO"};